import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API from '../services/api';

export default function CompanyForm() {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const isEdit = !!companyId;

  const [form, setForm] = useState({
    company_id: '',
    company_name: '',
    company_address: '',
    company_email: '',
    company_phone: '',
    company_city: '',
    company_state: '',
    company_country: '',
    company_username: '',
    company_password: '',
    company_status: 'active'
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  // Fetch countries
  useEffect(() => {
    fetch('https://countriesnow.space/api/v0.1/countries/positions')
      .then(res => res.json())
      .then(data => {
        if (data.data) {
          setCountries(data.data.map((c) => c.name).sort());
        }
      });
  }, []);

  // Fetch company details if editing
  useEffect(() => {
    if (isEdit) {
      API.get('/companies')
        .then((res) => {
          const list = Array.isArray(res.data) ? res.data : res.data.companies || [];
          const found = list.find((c) => c.company_id === companyId);
          if (found) {
            setForm({ ...found, company_password: '' });
          } else {
            alert('Company not found');
            navigate('/companies');
          }
        })
        .catch(() => alert('Failed to fetch company'));
    }
  }, [isEdit, companyId, navigate]);

  // Fetch states when country changes
  useEffect(() => {
    if (form.company_country) {
      fetch('https://countriesnow.space/api/v0.1/countries/states', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ country: form.company_country }),
      })
        .then(res => res.json())
        .then(data => {
          if (data.data?.states) {
            setStates(data.data.states.map(s => s.name));
            setCities([]);
            setForm(prev => ({ ...prev, company_state: '', company_city: '' }));
          }
        });
    }
  }, [form.company_country]);

  // Fetch cities when state changes
  useEffect(() => {
    if (form.company_country && form.company_state) {
      fetch('https://countriesnow.space/api/v0.1/countries/state/cities', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          country: form.company_country,
          state: form.company_state,
        }),
      })
        .then(res => res.json())
        .then(data => {
          if (data.data) {
            setCities(data.data);
            setForm(prev => ({ ...prev, company_city: '' }));
          }
        });
    }
  }, [form.company_state]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEdit) {
        const {
          company_name, company_address, company_email, company_phone,
          company_city, company_state, company_country, company_username
        } = form;

        await API.put(`/companies/${companyId}`, {
          company_name, company_address, company_email, company_phone,
          company_city, company_state, company_country, company_username
        });
        alert('Company updated');
      } else {
        await API.post('/companies', form);
        alert('Company created');
      }
      navigate('/companies');
    } catch {
      alert('Failed to save company');
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>{isEdit ? 'Edit Company' : 'Create Company'}</h2>
      <form onSubmit={handleSubmit}>
        {!isEdit && (
          <>
            <label>ID:</label><br />
            <input name="company_id" value={form.company_id} onChange={handleChange} disabled /><br /><br />
          </>
        )}
        <label>Name:</label><br />
        <input name="company_name" value={form.company_name} onChange={handleChange} required /><br /><br />

        <label>Email:</label><br />
        <input name="company_email" value={form.company_email} onChange={handleChange} required /><br /><br />

        <label>Phone:</label><br />
        <input name="company_phone" value={form.company_phone} onChange={handleChange} required /><br /><br />

        <label>Address:</label><br />
        <input name="company_address" value={form.company_address} onChange={handleChange} /><br /><br />

        <label>Country:</label><br />
        <select name="company_country" value={form.company_country} onChange={handleChange} required>
          <option value="">-- Select Country --</option>
          {countries.map((country, idx) => (
            <option key={idx} value={country}>{country}</option>
          ))}
        </select><br /><br />

        <label>State:</label><br />
        <select name="company_state" value={form.company_state} onChange={handleChange} required>
          <option value="">-- Select State --</option>
          {states.map((state, idx) => (
            <option key={idx} value={state}>{state}</option>
          ))}
        </select><br /><br />

        <label>City:</label><br />
        <select name="company_city" value={form.company_city} onChange={handleChange} required>
          <option value="">-- Select City --</option>
          {cities.map((city, idx) => (
            <option key={idx} value={city}>{city}</option>
          ))}
        </select><br /><br />

        <label>Username:</label><br />
        <input name="company_username" value={form.company_username} onChange={handleChange} required /><br /><br />

        {!isEdit && (
          <>
            <label>Password:</label><br />
            <input type="password" name="company_password" value={form.company_password} onChange={handleChange} required /><br /><br />
          </>
        )}

        <button type="submit">{isEdit ? 'Update' : 'Create'}</button>
      </form>
    </div>
  );
}
